<app-page-meta pageTitle="finzy - My Profile"></app-page-meta>
<div class="fluid-container">
  <app-header *ngIf="finzyDomain"></app-header>
  <app-theader *ngIf="otherDomain"></app-theader>
  <div class="back-div">
    <a style="color: #0d3ab3;" (click)="backToPreviousPage()"> < Back </a>
  </div>
  <div>

    <div class="content-profile-header">
      <p class="user-name text-center">
        {{name}}
      </p>
      <p class="your-profile text-center">
        Your Profile
      </p>
    </div>

    <div class="grey-section text-center">

      <div class="input-section">
        <div class="form-heading">Email Id</div>
        <div class="row">
          <mat-form-field class="col-xs-12">
            <input class="input-mat-field" type="text" matInput maxlength="35" [(ngModel)]="email" disabled>
            <mat-icon class="pointer" (click)="openDialog()" matSuffix>edit</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div class="input-section">
        <div class="form-heading">Mobile Number</div>
        <div class="row">
          <mat-form-field class="col-xs-12">
            <input class="input-mat-field" type="text" matInput maxlength="35" [(ngModel)]="mobile_no" disabled>
            <mat-icon matSuffix>lock</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="isLender" class="input-section">
        <div class="form-heading">Address</div>
        <div class="row">
          <mat-form-field class="col-xs-12">
            <input class="input-mat-field" type="text" matInput maxlength="35" [(ngModel)]="address" disabled>
            <mat-icon matSuffix>lock</mat-icon>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div *ngIf="isLender && !!bankAccount">

      <div class="content-profile-header">
        <p class="investment-bank-details">
          Investment Bank Details
        </p>
      </div>

      <div class="grey-section text-center">
        <div class="input-section">
          <div class="form-heading">Bank Name</div>
          <div class="row">
            <mat-form-field class="col-xs-12">
              <input class="input-mat-field" type="text" matInput maxlength="35" [(ngModel)]="bankAccount.bank_name" disabled>
              <mat-icon matSuffix>lock</mat-icon>
            </mat-form-field>
          </div>
        </div>

        <div class="input-section">
          <div class="form-heading">Account Name</div>
          <div class="row">
            <mat-form-field class="col-xs-12">
              <input class="input-mat-field" type="text" matInput maxlength="35" [(ngModel)]="bankAccount.accountHolderName" disabled>
              <mat-icon matSuffix>lock</mat-icon>
            </mat-form-field>
          </div>
        </div>

        <div class="input-section">
          <div class="form-heading">Bank Account No.</div>
          <div class="row">
            <mat-form-field class="col-xs-12">
              <input class="input-mat-field" type="text" matInput maxlength="35" [(ngModel)]="bankAccount.account_no" disabled>
              <mat-icon matSuffix>lock</mat-icon>
            </mat-form-field>
          </div>
        </div>

        <div class="input-section">
          <div class="form-heading">Account Type</div>
          <div class="row">
            <mat-form-field class="col-xs-12">
              <input class="input-mat-field" type="text" matInput maxlength="35" [(ngModel)]="bankAccount.account_type" disabled>
              <mat-icon matSuffix>lock</mat-icon>
            </mat-form-field>
          </div>
        </div>

        <div class="input-section">
          <div class="form-heading">IFSC Code</div>
          <div class="row">
            <mat-form-field class="col-xs-12">
              <input class="input-mat-field" type="text" matInput maxlength="35" [(ngModel)]="bankAccount.ifsc" disabled>
              <mat-icon matSuffix>lock</mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>

    </div>

  </div>


  <div class="text-center faq-contact-us">
    Check our <a [routerLink]="['/faq']" target="_blank">FAQs</a> or CALL <a href="tel: +919341300300">9341 300 300</a> for support
  </div>
</div>

<app-footer *ngIf="finzyDomain"></app-footer>
<app-tfooter *ngIf="otherDomain"></app-tfooter>
